import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PresaleInfo from './presaleInfo';
import SubmissionInfo from './submissionInfo';
import SecuredPoolCards from './securedPoolCards';
import PublicPoolCards from './publicPoolCards';
import InsurancePoolCards from './insurancePoolCards';
import { usePresale } from '../../contexts/PresaleContext';

function CountdownTimer({ targetDate, fontSize, title, endTitle }) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    function getTimeLeft() {
      const target = new Date(targetDate);
      const now = new Date();
      const diff = target - now;
      if (diff <= 0) return null;
      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
      };
    }
    setTimeLeft(getTimeLeft());
    const interval = setInterval(() => setTimeLeft(getTimeLeft()), 1000 * 30);
    return () => clearInterval(interval);
  }, [targetDate]);

  if (!timeLeft) return <span style={{ color: '#efbc00' }}>{endTitle}</span>;
  return (
    <span style={{}}>
      <span style={{ fontSize, fontWeight: 600, color: '#ccc' }}>{title}</span>
      <span style={{ fontSize, fontWeight: 600, color: '#efbc00' }}>
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
      </span>
    </span>
  );
}

const PresaleForm = () => {
  const navigate = useNavigate();
  const { isLoading, pools, privatePools, insurancePools } = usePresale();
  const [activeFilter, setActiveFilter] = useState('all');

  const filterButtons = [
    { id: 'all', label: 'All' },
    { id: 'insurance', label: 'Anti-Rug Policy' },
    { id: 'secured', label: 'Private Pools' },
    { id: 'public', label: 'Public Pools' }
  ];



  return (
    <div style={{ marginBottom: 150 }}>
      <section className="buy-crypto flat-tabs">
        <div className="container">
          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '30px',
            flexWrap: 'wrap',
            padding: '0 16px'
          }}>
            {filterButtons.map((button) => (
              <button
                key={button.id}
                onClick={() => setActiveFilter(button.id)}
                style={{
                  padding: '12px 24px',
                  borderRadius: '12px',
                  border: 'none',
                  background: activeFilter === button.id ? '#efbc00' : 'rgba(255,255,255,0.1)',
                  color: activeFilter === button.id ? '#000' : '#fff',
                  fontWeight: '700',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                  ':hover': {
                    background: activeFilter === button.id ? '#efbc00' : 'rgba(255,255,255,0.2)',
                  }
                }}
              >
                {button.label}
              </button>
            ))}
          </div>


          {(activeFilter === 'all' || activeFilter === 'insurance') && (
            <InsurancePoolCards
              insurancePools={insurancePools}
              isLoading={isLoading}
              CountdownTimer={CountdownTimer}
            />
          )}
          {(activeFilter === 'all' || activeFilter === 'secured') && (
            <SecuredPoolCards
              privatePools={privatePools}
              isLoading={isLoading}
              CountdownTimer={CountdownTimer}
            />
          )}
          {(activeFilter === 'all' || activeFilter === 'public') && (
            <PublicPoolCards
              pools={pools}
              isLoading={isLoading}
              CountdownTimer={CountdownTimer}
            />
          )}
          <PresaleInfo />
          <SubmissionInfo />
        </div>
      </section>
    </div>
  );
};

export default PresaleForm;